import { ButtonLink, ButtonModal } from "../../../../../../components";
import { TEMPLATE } from "../../../../../../constants";
import { handleMark } from "./functions";

const { MODAL_ACTION } = TEMPLATE.MODAL;

export const ActionItems = (
  record,
  setData,
  setIsOpenRemark,
  user,
  dispatch,
  messageApi
) => {
  const { status } = record;


  const menuItems = [
    {
      key: 1,
      label: user.uroleid === "A" && 
        ((status === 4 || status === 0) ? (
          <>Revert for processing</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_revert_for_processing_payroll}
            type="primary"
            style={{ width: "100%", height: "100%" }}
            onClick={() =>
              handleMark(record, "ready_for_processing", user, dispatch, messageApi)
            }
            extra={record}
          >
            Revert for processing
          </ButtonModal>
        )),
      disabled: user.uroleid === "A" && (status === 4 || status === 0),
    },
    {
      key: 2,
      label:
        user.uroleid === "A" &&
        ((status === 4 || status === 0) ? (
          <>Mark as cancelled</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_cancelled_payroll}
            type="primary"
            style={{ width: "100%", height: "100%" }}
            onClick={() =>
              handleMark(record, "cancelled", user, dispatch, messageApi)
            }
            extra={record}
            areatext="true"
          >
            Mark as cancelled
          </ButtonModal>
        )),
      disabled: user.uroleid === "A" && (status === 4 || status === 0),
    },
    {
      key: 3,
      label:
        user.uroleid === "A" &&
        ((status === 4 || status === 0) ? (
          <>Mark as disbursed</>
        ) : (
          <ButtonModal
            model={"link"}
            setmodal={MODAL_ACTION.confirmation_mark_as_disbursed_payroll}
            type="primary"
            style={{ width: "100%", height: "100%" }}
            onClick={() =>
              handleMark(record, "disbursed", user, dispatch, messageApi)
            }
            extra={record}
          >
            Mark as disbursed
          </ButtonModal>
        )),
      disabled: user.uroleid === "A" && (status === 4 || status === 0),
    },
    {
      key: 4,
      label: <ButtonLink>Edit remarks</ButtonLink>,
      onClick: () => {
        setIsOpenRemark(true);
        setData(record);
      },
    },
  ];

  const filteredMenuItems = menuItems.filter((item) => item.label !== false);
  return filteredMenuItems;
};